import * as types from '../types/index'

export const campaignCreateReducer = (state = {}, action) => {
	switch (action.type) {
		case types.CAMPAIGN_CREATE_REQUEST:
			return { loading: true }
		case types.CAMPAIGN_CREATE_SUCCESS:
			return { loading: false, campaign: action.payload }
		case types.CAMPAIGN_CREATE_FAIL:
			return { loading: false, error: action.payload }
		case types.CAMPAIGN_CREATE_RESET:
			return {}
		default:
			return state
	}
}

export const getCurrentCampaignReducer = (state = {}, action) => {
	switch (action.type) {
		case types.GET_CURRENT_CAMPAIGN_REQUEST:
			return { loading: true }
		case types.GET_CURRENT_CAMPAIGN_SUCCESS:
			return { loading: false, currentCampaign: action.payload }
		case types.GET_CURRENT_CAMPAIGN_FAIL:
			return { loading: false, error: action.payload }
		case types.GET_CURRENT_CAMPAIGN_RESET:
			return {}
		default:
			return state
	}
}

export const getCampaignDetailsReducer = (
	state = { campaignDetails: {} },
	action
) => {
	switch (action.type) {
		case types.GET_CAMPAIGN_DETAILS_REQUEST:
			return { loading: true, campaignDetails: {} }
		case types.GET_CAMPAIGN_DETAILS_SUCCESS:
			return { loading: false, campaignDetails: action.payload }
		case types.GET_CAMPAIGN_DETAILS_FAIL:
			return { loading: false, error: action.payload }
		case types.GET_CAMPAIGN_DETAILS_RESET:
			return { campaignDetails: {} }
		default:
			return state
	}
}

export const getAllCampaignsReducer = (state = {}, action) => {
	switch (action.type) {
		case types.GET_ALL_CAMPAIGNS_REQUEST:
			return { loading: true }
		case types.GET_ALL_CAMPAIGNS_SUCCESS:
			return { loading: false, campaigns: action.payload }
		case types.GET_ALL_CAMPAIGNS_FAIL:
			return { loading: false, error: action.payload }
		case types.GET_ALL_CAMPAIGNS_RESET:
			return {}
		default:
			return state
	}
}

export const campaignUpdateReducer = (state = {}, action) => {
	switch (action.type) {
		case types.UPDATE_CAMPAIGN_DETAILS_REQUEST:
			return { loading: true }
		case types.UPDATE_CAMPAIGN_DETAILS_SUCCESS:
			return { loading: false, success: true, campaign: action.payload }
		case types.UPDATE_CAMPAIGN_DETAILS_FAIL:
			return { loading: false, error: action.payload }
		case types.UPDATE_CAMPAIGN_DETAILS_RESET:
			return {}
		default:
			return state
	}
}

export const campaignUpdateStatusReducer = (state = {}, action) => {
	switch (action.type) {
		case types.UPDATE_CAMPAIGN_STATUS_REQUEST:
			return { loading: true }
		case types.UPDATE_CAMPAIGN_STATUS_SUCCESS:
			return { loading: false, success: true, campaign: action.payload }
		case types.UPDATE_CAMPAIGN_STATUS_FAIL:
			return { loading: false, error: action.payload }
		case types.UPDATE_CAMPAIGN_STATUS_RESET:
			return {}
		default:
			return state
	}
}
